import { type ValueOf } from '@/app/_shared/types'

export const UserRole = {
	USER: 'USER',
	ADMIN: 'ADMIN',
	GUEST: 'GUEST',
	SITE_MANAGER: 'SITE_MANAGER',
} as const
export type UserRole = ValueOf<typeof UserRole>

export const ListPageQueryFilters = {
	ORDER_BY: 'orderBy',
	ORDER_DIRECTION: 'orderDirection',
	SEARCH: 'search',
	PAGE: 'page',
} as const

export const ListPageOrderDirection = {
	ASC: 'asc',
	DESC: 'desc',
} as const
export type ListPageOrderDirection = ValueOf<typeof ListPageOrderDirection>

export const ToastType = {
	SUCCESS: 'success',
	INFO: 'info',
	WARNING: 'warning',
	ERROR: 'error',
} as const
export type ToastType = ValueOf<typeof ToastType>
